import { InjectionToken } from '@angular/core';

import { Notification, NotificationData } from './notification.interface';
import { UserNotification } from './user-notification.interface';

export const SIGNALR_NOTIFICATION_HANDLER: InjectionToken<NotificationHandler<any>> = new InjectionToken('SIGNALR_NOTIFICATION_HANDLER');

export interface NotificationHandler<T extends NotificationData> {
	/** Filters the notification type */
	dataType: string;

	/**
	 * Will be fired when a notification is received for this handler by SignalR.
	 *
	 * @param notification
	 */
	handleNotification(notification: Notification<T>): void;

	/**
	 * Format a notification to display it in the user notification dropdown, return null to skip adding it to the notification dropdown.
	 * @param notification
	 */
	formatUserNotification(notification: Notification<T>): UserNotification<T>;

	/**
	 * Fires when the notification in the notification dropdown gets clicked
	 * @param notification
	 */
	onClick(notification: UserNotification<T>): void;
}
